/* tslint:disable:no-small-switch */
import { BpOverlayComponentConstructor } from '../../models/component.model';
import { SSRTextPlacementContentContentTypeEnum } from '@ads-ep/fetch-api-client';
import { SsrOverlayComponent } from '../../components/overlays/ssr-overlay/ssr-overlay.component';
import { OverlayContentType } from '../../models/overlay.model';
import { RtpsOverlayComponent } from '../../components/overlays/rtps-overlay/rtps-overlay.component';
import overlayBaseTemplate from '../../services/overlay/base-overlay-container.component.html';
import { SSRTextPlacementContentType } from './placement-constructor-lookup.util';

export function lookupOverlayConstructor(componentType: string):
  BpOverlayComponentConstructor<SsrOverlayComponent | RtpsOverlayComponent>{
  switch(componentType){
    case SSRTextPlacementContentType:
      return SsrOverlayComponent;

    case OverlayContentType.RtpsOverlay:
      return RtpsOverlayComponent;
  }

  return SsrOverlayComponent;
}

export function getOverlayBaseTemplateByComponentType(componentType: string): ()=>string{
  switch(componentType){
    case SSRTextPlacementContentType:
      return overlayBaseTemplate;

    case OverlayContentType.RtpsOverlay:
      return overlayBaseTemplate;
  }
}
